/* =========================================================================
   Flight Box - Setup instructions page behaviours
   No dependencies. Safe to load once per page.
   Re-runs on Shopify theme-editor section load/select events.
   ========================================================================= */
(function () {
  'use strict';

  var INIT = 'fbInit';

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function done(el) { if (el.dataset[INIT]) return true; el.dataset[INIT] = '1'; return false; }

  /* ---------------------------------------------------------------
     Accordions
     One <button> + one panel. Optionally single-open per group.
     --------------------------------------------------------------- */
  function initAccordions(root) {
    qsa(root, '[data-fb-ac]').forEach(function (group) {
      if (done(group)) return;

      var single = group.dataset.fbAc === 'single';
      var buttons = qsa(group, '.fb-ac__btn');

      buttons.forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;

        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';

          if (single && !open) {
            buttons.forEach(function (other) {
              if (other === btn) return;
              var op = document.getElementById(other.getAttribute('aria-controls'));
              other.setAttribute('aria-expanded', 'false');
              if (op) op.hidden = true;
            });
          }

          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Mobile tabs (step 4: "Near me" / "One flight")
     Desktop shows both panes side by side, so the tabs only drive
     visibility below the breakpoint. CSS forces both visible above it.
     --------------------------------------------------------------- */
  function initTabs(root) {
    qsa(root, '[data-fb-tabs]').forEach(function (wrap) {
      if (done(wrap)) return;

      var tabs = qsa(wrap, '.fb-tab');
      var panes = qsa(wrap, '[data-fb-pane]');
      if (!tabs.length || !panes.length) return;

      var narrow = window.matchMedia('(max-width: 899px)');
      var active = 0;

      function apply() {
        // Tabs are a phone affordance. Above the breakpoint every pane is
        // shown, and nothing is left marked hidden for screen readers.
        var tabbed = narrow.matches;

        tabs.forEach(function (tab, i) {
          tab.setAttribute('aria-selected', i === active ? 'true' : 'false');
          tab.setAttribute('tabindex', i === active ? '0' : '-1');
        });

        panes.forEach(function (pane, i) {
          pane.hidden = tabbed ? i !== active : false;
        });
      }

      function select(index) {
        active = index;
        apply();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });

        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (next === null) return;
          event.preventDefault();
          select(next);
          tabs[next].focus();
        });
      });

      if (narrow.addEventListener) {
        narrow.addEventListener('change', apply);
      } else if (narrow.addListener) {
        narrow.addListener(apply);           // Safari < 14
      }

      apply();
    });
  }

  /* ---------------------------------------------------------------
     Mobile sticky step bar
     Tapping it opens the step list; scrolling updates the label.
     --------------------------------------------------------------- */
  function initStepBar(root) {
    qsa(root, '[data-fb-stepbar]').forEach(function (bar) {
      if (done(bar)) return;

      var button = bar.querySelector('.fb-stepbar');
      var list = bar.querySelector('.fb-stepbar__list');
      var label = bar.querySelector('[data-fb-stepbar-label]');
      if (!button || !list) return;

      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', open ? 'false' : 'true');
        list.classList.toggle('is-open', !open);
      });

      qsa(list, 'a').forEach(function (link) {
        link.addEventListener('click', function () {
          button.setAttribute('aria-expanded', 'false');
          list.classList.remove('is-open');
        });
      });

      if (!label) return;

      var wordStep = bar.dataset.fbWordStep || 'Step';
      var wordOf = bar.dataset.fbWordOf || 'of';
      var wordSep = bar.dataset.fbWordSep || '-';
      var steps = qsa(document, '[data-fb-step]');
      if (!steps.length) return;

      function paint() {
        var barBottom = bar.getBoundingClientRect().bottom;
        var current = steps[0];
        var index = 0;

        steps.forEach(function (step, i) {
          if (step.getBoundingClientRect().top - barBottom <= 24) {
            current = step;
            index = i;
          }
        });

        var n = current.dataset.fbStepN || String(index + 1);
        var title = current.dataset.fbStepTitle || '';
        var text = wordStep + ' ' + n + ' ' + wordOf + ' ' + steps.length;
        if (title) text += ' ' + wordSep + ' ' + title;

        if (label.textContent !== text) label.textContent = text;
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { paint(); ticking = false; });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      paint();
    });
  }

  /* ---------------------------------------------------------------
     Carousel arrows (mobile)
     The track is a scroll-snap row, so the arrows just scroll it by
     one item. They hide themselves when there is nothing to scroll.
     --------------------------------------------------------------- */
  function initCarousels(root) {
    qsa(root, '[data-fb-carousel]').forEach(function (wrap) {
      if (done(wrap)) return;

      var track = wrap.querySelector('.fb-grid--swipe');
      var prev = wrap.querySelector('[data-fb-car="prev"]');
      var next = wrap.querySelector('[data-fb-car="next"]');
      var count = wrap.querySelector('[data-fb-car-count]');
      if (!track || !prev || !next) return;

      // Items hidden on mobile are not pageable, so they don't count.
      function panes() {
        return qsa(track, '.fb-item').filter(function (el) {
          return el.offsetParent !== null || el.getClientRects().length;
        });
      }

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function scrollable() {
        return track.scrollWidth - track.clientWidth > 2;
      }

      function paint() {
        // No overflow means nothing to page through - desktop, or a single image.
        wrap.classList.toggle('has-arrows', scrollable());
        if (!scrollable()) return;
        var x = track.scrollLeft;
        prev.disabled = x <= 2;
        next.disabled = x >= track.scrollWidth - track.clientWidth - 2;
        if (count) {
          var total = panes().length;
          var per = step() || 1;
          var index = Math.min(total, Math.round(x / per) + 1);
          count.textContent = total > 1 ? index + '/' + total : '';
        }
      }

      function go(dir) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', paint, { passive: true });
      window.addEventListener('resize', paint, { passive: true });
      paint();
    });
  }

  /* ---------------------------------------------------------------
     Desktop step chips - highlight the step you are reading
     --------------------------------------------------------------- */
  function initStepNav(root) {
    qsa(root, '[data-fb-stepnav]').forEach(function (nav) {
      if (done(nav)) return;

      var chips = qsa(nav, '.fb-chip');
      var steps = qsa(document, '[data-fb-step]');
      if (!chips.length || !steps.length) return;

      function paint() {
        var offset = nav.getBoundingClientRect().bottom;

        // -1 until the first step has actually been scrolled to, so nothing is
        // highlighted while the hero is still on screen.
        var index = -1;

        steps.forEach(function (step, i) {
          if (step.getBoundingClientRect().top - offset <= 24) index = i;
        });

        chips.forEach(function (chip, i) {
          chip.classList.toggle('is-current', i === index);
        });
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { paint(); ticking = false; });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      paint();
    });
  }

  /* ---------------------------------------------------------------
     Mobile-only collapse
     Whole sections fold into an accordion on phones. Above the
     breakpoint the toggle is hidden by CSS and the panel always shows,
     so the collapsed state is only ever applied while narrow.
     --------------------------------------------------------------- */
  function initMobileCollapse(root) {
    qsa(root, '[data-fb-mcollapse]').forEach(function (wrap) {
      if (done(wrap)) return;

      var btn = wrap.querySelector('.fb-mcollapse__btn');
      var panel = wrap.querySelector('.fb-mcollapse__panel');
      if (!btn || !panel) return;

      var narrow = window.matchMedia('(max-width: 899px)');

      function sync() {
        if (narrow.matches) {
          var open = btn.getAttribute('aria-expanded') === 'true';
          panel.classList.toggle('is-collapsed', !open);
        } else {
          // Desktop shows everything; drop the collapsed state entirely.
          panel.classList.remove('is-collapsed');
        }
      }

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        sync();
      });

      if (narrow.addEventListener) {
        narrow.addEventListener('change', sync);
      } else if (narrow.addListener) {
        narrow.addListener(sync);           // Safari < 14
      }

      sync();
    });
  }

  /* ---------------------------------------------------------------
     Smart store button (mobile)
     Sends iOS to the App Store and everything else to Google Play.
     --------------------------------------------------------------- */
  function initSmartStore(root) {
    qsa(root, '[data-fb-smart-store]').forEach(function (wrap) {
      if (done(wrap)) return;

      var ua = navigator.userAgent || '';

      // iPadOS 13+ reports as a Mac, so check for touch as well.
      var isIos = /iPhone|iPad|iPod/i.test(ua) ||
        (/Macintosh/i.test(ua) && typeof document.ontouchend !== 'undefined');

      var preferred = isIos ? 'ios' : 'android';
      var badges = qsa(wrap, '[data-fb-store]');

      // A badge whose store URL has not been filled in yet is no use — if the
      // one for this device is unset but the other has a link, show that
      // instead of a dead badge.
      var usable = function (badge) {
        var href = badge.getAttribute('href') || '';
        return href && href !== '#';
      };
      var wanted = badges.filter(function (b) {
        return b.getAttribute('data-fb-store') === preferred;
      })[0];
      if (wanted && !usable(wanted) && badges.some(usable)) {
        preferred = preferred === 'ios' ? 'android' : 'ios';
      }

      badges.forEach(function (badge) {
        if (badge.getAttribute('data-fb-store') !== preferred) {
          badge.style.display = 'none';
        }
      });
    });
  }

  /* ---------------------------------------------------------------
     Smooth in-page jumps that clear the sticky bars
     --------------------------------------------------------------- */
  function initAnchors(root) {
    qsa(root, '[data-fb-jump]').forEach(function (link) {
      if (done(link)) return;

      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href') || '';
        if (id.charAt(0) !== '#' || id.length < 2) return;

        var target = document.getElementById(id.slice(1));
        if (!target) return;

        event.preventDefault();

        var stuck = document.querySelector('.fb-stepnav__sticky, .fb-stepbar');
        var offset = stuck ? stuck.getBoundingClientRect().height + 12 : 12;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });

        // Move keyboard focus too, or the jump is visual only.
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  /* --------------------------------------------------------------- */
  function initAll(root) {
    var scope = root || document;
    initAccordions(scope);
    initTabs(scope);
    initStepBar(scope);
    initStepNav(scope);
    initCarousels(scope);
    initMobileCollapse(scope);
    initSmartStore(scope);
    initAnchors(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target);
  });
})();
